import ProgramBookingPaidAndRefundDetail from "../../reservationHistory/detail/programBookingDetail/paidAndRefundDetail";

const PaidHistoryProgramDetail = () => {

    return <>
        <ProgramBookingPaidAndRefundDetail />
    </>
}

export default PaidHistoryProgramDetail